import React, { useState, useContext, useEffect, useRef } from 'react';
import { uploadimagetoserver } from '../../../Api/contact';
import { API_URL } from '../../../Api/config';
import Loader2 from '../Loader/Loader2';

const VideoUpload = ({ swingdata,step }) => {
    
    const [isLoading, setIsLoading] = useState(false);
    const videoRef = useRef();
    const uploadImageToServer = async (file) => {
        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append('image', file);

            const res = await uploadimagetoserver(formData);
            if (res.data?.status) {
                const filename = res.data.data;
            } else {
                alert(res.data.data[0]?.detail || 'Error uploading image');
            }
        } catch (error) {
            console.error("Error uploading image:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileChange = () => {

    }


    return (
        <>
            {isLoading ? (
                <div className="loading">
                    <Loader2 />
                </div>
            ) : (
                <div className="card-video">
                    <div className={'drop_box'}>
                        <input
                            type="file"
                            accept=".mp4,.avi,.mkv"
                            id={`${step}.swing1.fileID`}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        {swingdata.swing1 && (
                            <div className="form">
                                <video
                                    ref={videoRef}
                                    playsInline
                                    autoPlay={false}
                                    controls
                                    preload="metadata"
                                    style={{ width: '100%', position: "absolute", top: "0", left: "0", height: "100%", borderRadius: "1.5rem" }}
                                >
                                        <source src={swingdata.swing1 + ''} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        )}
                        {/* {!filmswingvalidate && ( */}
                            <div className="custom-upload-btn">
                                <button className="btn-upload" onClick={() => document.getElementById(`${step}.swing1.fileID`).click()}>
                                    <img src={require('../../../assets/images/photo-camera.png')} alt="upload" />
                                </button>
                            </div>
                        {/* )} */}
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoUpload;
